import React, { useState } from 'react';
import { brand } from '../../config/brand';
import { useReveal } from '../../hooks/useReveal';
import SplitText from '../SplitText';
import Brief from '../Brief/Brief';
import './Contact.css';

const Contact: React.FC = () => {
  const ref = useReveal();
  const [copied, setCopied] = useState(false);

  const copyEmail = async (e: React.MouseEvent) => {
    e.preventDefault();
    try {
      await navigator.clipboard.writeText(brand.agency.email);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.location.href = `mailto:${brand.agency.email}`;
    }
  };

  return (
    <section className="contact section" id="contact" aria-labelledby="contact-heading" ref={ref}>
      <div className="container">
        <div className="contact__card reveal">
          <div className="contact__inner">
            <div className="contact__copy">
              <span className="section-label contact__label reveal reveal-delay-1">Start a project</span>
              <h2 className="contact__heading reveal reveal-delay-2" id="contact-heading">
                <SplitText text={brand.contact.heading} highlight="shipping." />
              </h2>
              <p className="contact__sub reveal reveal-delay-3">{brand.contact.sub}</p>

              <p className="contact__coverage reveal reveal-delay-4">
                {brand.contact.responseTime}. {brand.agency.coverage}
              </p>

              {/* Email and LinkedIn stay available, but they are the fallback
                  now — the form is the path we actually want people on. */}
              <div className="contact__fallback reveal reveal-delay-4">
                <span className="contact__fallback-label">Rather do it the old way?</span>
                <div className="contact__fallback-links">
                  <a
                    href={`mailto:${brand.agency.email}`}
                    className="contact__fallback-link"
                    id="contact-email-link"
                  >
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 01-2.06 0L2 7"/></svg>
                    {brand.agency.email}
                  </a>
                  <button
                    type="button"
                    className={`contact__copy-btn${copied ? ' is-copied' : ''}`}
                    onClick={copyEmail}
                    aria-label="Copy email address"
                  >
                    {copied ? 'Copied ✓' : 'Copy'}
                  </button>
                  {brand.social.linkedin && (
                    <a
                      href={brand.social.linkedin}
                      className="contact__fallback-link"
                      target="_blank"
                      rel="noopener noreferrer"
                      id="contact-linkedin-link"
                    >
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
                      LinkedIn
                    </a>
                  )}
                </div>
              </div>
            </div>

            <div className="contact__form reveal reveal-delay-3">
              <Brief />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
